import {createActions} from 'client/framework';

export default createActions(null, ['SET_SEARCH_STRING', 'RESET_STORE']);
